import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <>
    <path
      fill="currentColor"
      d="M 16.584 16.174 s -0.653 0.635 -0.814 0.82 c -0.26 0.276 -0.568 0.406 -0.97 0.406 c -0.039 0 -0.08 0 -0.119 -0.003 c -0.767 -0.048 -1.48 -0.343 -2.014 -0.596 a 11.448 11.448 0 0 1 -3.81 -2.945 c -0.88 -1.047 -1.47 -2.015 -1.859 -3.055 c -0.24 -0.634 -0.328 -1.128 -0.29 -1.595 c 0.027 -0.298 0.143 -0.545 0.357 -0.756 l 0.88 -0.87 c 0.127 -0.116 0.261 -0.18 0.393 -0.18 c 0.162 0 0.294 0.097 0.377 0.178 l 0.008 0.008 c 0.157 0.145 0.307 0.296 0.464 0.456 l 0.245 0.247 l 0.705 0.696 c 0.274 0.27 0.274 0.52 0 0.79 c -0.075 0.073 -0.147 0.147 -0.222 0.219 c -0.217 0.219 -0.046 0.05 -0.27 0.25 c -0.006 0.004 -0.011 0.007 -0.014 0.012 c -0.222 0.22 -0.18 0.433 -0.134 0.578 l 0.008 0.023 c 0.183 0.439 0.441 0.851 0.834 1.343 l 0.002 0.003 c 0.713 0.866 1.464 1.541 2.293 2.058 c 0.106 0.066 0.214 0.12 0.317 0.17 c 0.093 0.047 0.181 0.09 0.256 0.136 l 0.03 0.018 c 0.089 0.043 0.171 0.063 0.256 0.063 a 0.554 0.554 0 0 0 0.393 -0.175 l 0.506 -0.5 c 0.088 -0.086 0.227 -0.19 0.39 -0.19 c 0.16 0 0.291 0.099 0.371 0.185 l 0.006 0.005 l 1.422 1.404 c 0.266 0.26 0.003 0.797 0.003 0.797 Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M 8.222 20.784 a 9.567 9.567 0 0 0 3.878 0.816 a 9.6 9.6 0 1 0 -8.373 -4.901 L 2.5 21.602 l 5.721 -0.818 Z"
      fill="none"
    />
  </>,
  'WhatsApp'
)
